exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/core-js/modules/_wks-ext.js
// module id = 444
// module chunks = 8